var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.492 2.419-0.8906 1.331h6.797l-0.8906-1.331c-0.07031-0.1031-0.1875-0.1688-0.3141-0.1688h-4.392c-0.1266 0-0.2438 0.06094-0.3141 0.1688zm6.891-1.247 1.72 2.578h3.272c0.6234 0 1.125 0.5016 1.125 1.125 0 0.6234-0.5016 1.125-1.125 1.125h-0.375v14.25c0 2.072-1.678 3.75-3.75 3.75h-10.5c-2.072 0-3.75-1.678-3.75-3.75v-14.25h-0.375c-0.6234 0-1.125-0.5016-1.125-1.125 0-0.6234 0.5016-1.125 1.125-1.125h3.272l1.72-2.583c0.4875-0.7266 1.308-1.167 2.184-1.167h4.392c0.8766 0 1.697 0.4406 2.184 1.167zm-11.13 4.828v14.25c0 0.8297 0.6703 1.5 1.5 1.5h10.5c0.8297 0 1.5-0.6703 1.5-1.5v-14.25zm3.75 3v9.75c0 0.4125-0.3375 0.75-0.75 0.75s-0.75-0.3375-0.75-0.75v-9.75c0-0.4125 0.3375-0.75 0.75-0.75s0.75 0.3375 0.75 0.75zm3.75 0v9.75c0 0.4125-0.3375 0.75-0.75 0.75s-0.75-0.3375-0.75-0.75v-9.75c0-0.4125 0.3375-0.75 0.75-0.75s0.75 0.3375 0.75 0.75zm3.75 0v9.75c0 0.4125-0.3375 0.75-0.75 0.75s-0.75-0.3375-0.75-0.75v-9.75c0-0.4125 0.3375-0.75 0.75-0.75s0.75 0.3375 0.75 0.75z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.d01284e6c80b11748112c2586ceeb11a.svg";
export { ForwardRef as ReactComponent };